import { createI18n } from 'vue-i18n'

import enUS from '@/i18n/locales/en-US'
import jaJP from '@/i18n/locales/ja-JP'
import zhCN from '@/i18n/locales/zh-CN'
import { DEFAULT_LOCALE, SUPPORTED_LOCALES, type UiLocale } from '@/i18n/schema'

export const messages = {
  'zh-CN': zhCN,
  'en-US': enUS,
  'ja-JP': jaJP,
} as const

/**
 * 判断 locale 是否在受支持列表中。
 *
 * @param value - 候选语言代码
 */
export function isSupportedLocale(value: string): value is UiLocale {
  return (SUPPORTED_LOCALES as readonly string[]).includes(value)
}

export const i18n = createI18n({
  legacy: false,
  locale: DEFAULT_LOCALE,
  fallbackLocale: 'en-US',
  messages,
  missingWarn: import.meta.env.DEV,
  fallbackWarn: import.meta.env.DEV,
})
